import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';

const useCancelCohortAction = ({ category, code }) => useSelector(({ cohorts: { cohorts } }) => {
  const cohort = findResult(cohorts, category, code);

  return {
    cohort,
    isDirty: cohort ? cohort.isDirty : false,
  };
});

export default {
  useCancelCohortAction,
};
